/// DEFAULT APP SETTINGS IF NO PROFILE IS CHOSEN
export class CustomerAppSettings
{
ApiUrl: string  = "";//= "http://healins.cloudapp.net/k1newapi/" 
GlobalApiUrl: string  = "";//= "http://healins.cloudapp.net/GlobalApi/"
  ClientLogoUrl: string = "";
  ClientHeaderUrl: string = "";
  ClientHeaderLine1: string = "";
  ClientHeaderLine2: string = "";
  ClientHeaderSubTitle1: string = "";
  ClientHeaderSubTitle2: string = "";
  ClientHeaderFooterLine1: string = "";
  ClientHeaderFooterLine2: string = "";
  ClientHeaderFooterLine3: string = "";
  ClientHeaderFooterLine4: string = "";
  Hlogo: string = "";
  HlogoWidth: number = 0;
  HlogoHeight: number = 0;
  Navlogo: string = "";
  PrintlogoWidth: number = 0;
  PrintlogoHeight: number = 0;
  PrintlogoBorderRadius: number = 0;
  RXLogoUrl: string = "";
  RXHeaderUrl: string = "";
  RXHeaderLine1: string = "";
  RXHeaderLine2: string = "";
  RXHeaderSubTitle1: string = "";
  RXHeaderSubTitle2: string = "";
  RXHeaderSubTitle1Value: string = "";
  RXHeaderSubTitle2Value: string = "";
  RXHeaderFooterLine1: string = "";
  RXHeaderFooterLine2: string = "";
  RXHeaderFooterLine3: string = "";
  RXHeaderFooterLine4: string = "";
  RXlogo: string = "";
  RxDefault_StoreCode: number = 0;


  Prescribing_DoctorName: string = "";
  Prescribing_DoctorCode: number = 0;
  Prescribing_Designation: string = "";
  BckgImg: string = "";

  LoginCountry: string = "";
  LoginState: string = "";
  LoginCity: string = "";
  LoginPinCode: string = "";
  Terms_Conditions: string = "";

  OPBillTitle: string = "";
  DotMatrixPrint: string = "";
  LaserPrint: string = "";
  ShowBillPrintHeaderLogoCustomer: string = "";
  ShowBillPrintHeaderLogo: string = "";
  BillPrintHeaderHeight: number = 0;
  BillPrintHeaderEmpty: string = "";
  ShowBillPrintFooter: string = "";
  ShowBillPrintFooterEmpty: string = "";
  BillPrintFooterHeight: number = 0;
  DmFont: string = "";
  RXDmFont: string = "";
  BillPrintBodyWithPatientDetails: string = "";

  ShowLabPrintHeaderLogoCustomer: string = "";
  ShowLabPrintHeaderLogo: string = "";
  LabPrintHeaderHeight: number = 0;
  LabPrintHeaderEmpty: string = "";
  ShowLabPrintFooter: string = "";
  ShowLabPrintFooterEmpty: string = "";
  LabPrintFooterHeight: number = 0;
  LabPrintBodyWithPatientDetails: string = "";

  ShowGeneralPrintHeaderLogoCustomer: string = "";
  ShowGeneralPrintHeaderLogo: string = "";
  GeneralPrintHeaderHeight: number = 0;
  GeneralPrintHeaderEmpty: string = "";
  ShowGeneralPrintFooter: string = "";
  ShowGeneralPrintFooterEmpty: string = "";
  GeneralFooterHeight: number = 0;
  GeneralPrintBodyWithPatientDetails: string = "";

  RXBillTitle: string = "";
  RXDotMatrixPrint: string = "";
  RXLaserPrint: string = "";
  ShowRXPrintHeaderLogoCustomer: string = "";
  ShowRXPrintHeaderLogo: string = "";
  RXPrintHeaderHeight: number = 0;
  RXPrintHeaderEmpty: string = "";
  ShowRXPrintFooter: string = "";
  ShowRXPrintFooterEmpty: string = "";
  RXPrintFooterHeight: number = 0;
  RXPrintBodyWithPatientDetails: string = "";
  RXA5width: number = 100;
  RXITEMCOLS: string = "";
  RXFontFamily: string = "";
  RXFontSize: number = 14;
  RXMarginLayoutLeft: number = 0.5;
  RXMarginLayoutRight: number = 0;
  RXMarginLayoutTop: number = 0.5;
  RXMarginLayoutBottom: number = 0;

  AsstSurgeon: string = "";
}

//export class CustomerAppBranchSettings {

//  ApiUrl: string = "";//= "http://healins.cloudapp.net/k1newapi/" 
//  GlobalApiUrl: string = "";//= "http://healins.cloudapp.net/GlobalApi/"
//  ClientLogoUrl: string = "";
//  ClientHeaderUrl: string = "";
//  ClientHeaderLine1: string = "";
//  ClientHeaderLine2: string = "";
//  ClientHeaderFooterLine1: string = "";
//  ClientHeaderFooterLine2: string = "";
//  ClientHeaderFooterLine3: string = "";
//  ClientHeaderFooterLine4: string = "";

//  Hlogo: string = "";

//  RXLogoUrl: string = "";
//  RXHeaderUrl: string = "";
//  RXHeaderLine1: string = "";
//  RXHeaderLine2: string = "";
//  RXHeaderFooterLine1: string = "";
//  RXHeaderFooterLine2: string = "";
//  RXHeaderFooterLine3: string = "";
//  RXHeaderFooterLine4: string = "";
  
//}
